// extracted by mini-css-extract-plugin
export default {"container":"ImagesContainer_container__Mofi4","mainImage":"ImagesContainer_mainImage__5vni1","smallImage":"ImagesContainer_smallImage__uHimh"};